import { render, staticRenderFns } from "./P.vue?vue&type=template&id=dc8dd3ac&scoped=true&"
import script from "./P.vue?vue&type=script&lang=js&"
export * from "./P.vue?vue&type=script&lang=js&"
import style0 from "./P.vue?vue&type=style&index=0&id=dc8dd3ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8dd3ac",
  null
  
)

export default component.exports